import { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { AppLayout } from "./components/layout/AppLayout";
import { NotFound } from "./pages/NotFound";
import { Loading } from "./components/ui";
import { AppErrorBoundary } from "./components/system/AppErrorBoundary";
import { InstallGate } from "./routes/InstallGate";
import { publicRoutes } from "./routes/publicRoutes";
import { authRoutes } from "./routes/authRoutes";
import { clientRoutes } from "./routes/clientRoutes";
import { adminRoutes } from "./routes/adminRoutes";
import { installRoutes } from "./routes/installRoutes";

/**
 * Routeur FR complet — 44 pages de SITE_SPEC §3 (public 17 · auth 3 · client 12 · admin 12)
 * + l'assistant /install (§8). Les groupes de routes vivent dans `src/routes/*` ; les agents
 * Pages n'éditent que les composants de page (`src/pages/{section}/*`).
 *
 * GARDES (SITE_SPEC §8.1, §2.3) :
 *  - <InstallGate> (installer-guard) : redirige tout vers /install tant que non installé.
 *  - <ClientLayout> (auth-guard) : /panel/* exige une session (→ /connexion sinon).
 *  - <AdminLayout> (role-guard) : /admin/* exige STAFF+ (accès refusé sinon).
 *
 * L'Accueil (Home) reste la page de référence stylée de la coquille.
 */
export default function App() {
  return (
    <AppErrorBoundary>
      <InstallGate>
      <Suspense fallback={<Loading className="py-32" />}>
        <Routes>
          {/* Installeur — hors coquille, plein écran, non gardé (c'est sa destination). */}
          {installRoutes}

          {/* Reste du site sous la coquille globale (Header + Footer). */}
          <Route element={<AppLayout />}>
            {publicRoutes}
            {authRoutes}
            {clientRoutes}
            {adminRoutes}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>
      </InstallGate>
    </AppErrorBoundary>
  );
}
